module.exports = __webpack_public_path__ + "img/pin.522181a1.svg";